import { render } from "./CursorBlob.vue?vue&type=template&id=2d5e7881&ts=true"
import script from "./CursorBlob.vue?vue&type=script&lang=ts"
export * from "./CursorBlob.vue?vue&type=script&lang=ts"

import "./CursorBlob.vue?vue&type=style&index=0&id=2d5e7881&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__